import React from 'react'
import Dashboard from '../components/DocVault/Dashboard'

const DocVault = () => {
  return (
    <Dashboard></Dashboard>
  )
}

export default DocVault